import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { AuthContext, useAuth } from 'context/AuthContext'
import { useEffect } from 'react'
import { createModal } from '../ModalFactory'
import { ModalWrapper } from '../ModalWrapper'
import UpsellPricingSection from './section-pricing'
import getConfig from 'next/config'

const ModalProvider = createModal(AuthContext, 'UpsellModal', () => (
    <div>Show Upsell</div>
))

export const UpsellModalOpener = ModalProvider.Opener
export const UpsellModalCloser = ModalProvider.Closer

function UpsellModal() {
    const { UpsellModal } = useAuth()
    const { translations, loadComponentTranslations } = useAppContext()
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    function handleClose() {
        UpsellModal.close()
    }

    useEffect(() => {
        if (!translations.LANDING_TRANSLATION_ID) {
            loadComponentTranslations('LANDING_TRANSLATION_ID')
        }
    }, [translations])

    return (
        <ModalProvider.Visible>
            <ModalWrapper>
                <div className="relative bg-white rounded-xl overflow-hidden">
                    <div className="absolute bg-[#E5EEF6] h-[35rem] w-full overflow-hidden">
                        <div className="relative bg-[#86C5E0] rounded-full h-screen w-2/3 top-72 mx-auto">
                            <div className="absolute bg-[#C4E2EE] rounded-full h-32 w-32 right-28 -top-5" />
                            <div
                                className="relative bg-contain bg-no-repeat h-venti w-road left-44 -top-16"
                                style={{
                                    backgroundImage:
                                        'url(//static.aot.plus/images/beautiful-young-female-athlete-min.png)',
                                }}
                            />
                        </div>
                    </div>

                    <div className="relative p-8">
                        <div className="text-right">
                            <UpsellModalCloser />
                        </div>
                        <div className="text-primary text-center">
                            <div className="text-3xl font-bold leading-normal">
                                <Translation content_key='common.upgrade_plan' />
                            </div>
                            <div className="leading-normal w-3/6 mx-auto">
                                <Translation content_key='common.upgrade_plan_sub' />
                            </div>
                        </div>
                        <div className="h-44"></div>
                        <div className="px-5">
                            <UpsellPricingSection {...translations} />
                        </div>

                        <div className="text-center mt-10">
                            <span
                                className="text-lg text-primary-dark cursor-pointer"
                                onClick={handleClose}
                            >
                                <Translation content_key='common.check_later' />
                            </span>
                        </div>
                    </div>
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}

export default UpsellModal
